import Link from 'next/link';
import { css } from 'styled-components';
import { DebugInfo } from '@/app/components/hotel-detail/rooms/RoomPanelCommon.tsx';
import { DebugAuth } from '@/app/components/common/DebugAuth.tsx';
import { useInitialParams } from '@/app/components/hotel-detail/InitialParamsProvider.tsx';
import { useCreateAsyncPricing } from '@/app/components/hotel-detail/PricingProvider.tsx';
import { DEBUG_VISIBILITY, useDebugVisibility } from '@/app/components/hotel-detail/hooks/useDebugVisibility.ts';

type DebugRoomInfoProps = {
  mealPlan: MealPlanType;
  roomId: string;
};
export const DebugRoomInfo = ({ mealPlan, roomId }: DebugRoomInfoProps) => {
  const initialParams = useInitialParams();
  const { data: asyncPricing } = useCreateAsyncPricing();
  const visibility = useDebugVisibility();
  if (visibility === DEBUG_VISIBILITY.HIDDEN) return null;

  return visibility === DEBUG_VISIBILITY.VISIBLE ? (
    <Link
      href={`/debug/rooms?pricingId=${asyncPricing?.pricingId}&room=${roomId}&mealplan=${mealPlan?.id}`}
      target="_blank"
      rel="noreferrer"
      css={css`
        color: ${(p) => p.theme.commons.colors.gray800};
      `}
    >
      <DebugInfo>{`${initialParams.internalHotelId} | ${mealPlan?.supplier?.id} | RoomId: ${roomId} - ${mealPlan?.supplier?.roomId}`}</DebugInfo>
    </Link>
  ) : (
    <DebugAuth />
  );
};
